import { Box, Text } from '@chakra-ui/react';
import { outreachFunctions } from '@/constants/outreach-functions';

export const Function = ({
  count = 0,
  selected = null,
  func,
  onClick = () => {},
  trackingID = '',
}) => {
  const onClickFn = () => {
    onClick(func?.value);
  };

  return (
    <Text
      cursor="pointer"
      fontSize="14px"
      ml="-8px"
      p="8px"
      bg={selected === func?.value ? 'rgba(0, 67, 206, 0.1)' : 'white'}
      color={selected === func?.value ? '#0043CE' : 'inherit'}
      fontWeight={selected === func?.value ? '600' : '400'}
      borderRadius="6px"
      _hover={{
        bg: 'rgba(0, 67, 206, 0.1)',
        color: '#0043CE',
        fontWeight: 600,
      }}
      onClick={onClickFn}
      data-tracking-id={trackingID}
      data-test-id={trackingID}
    >
      {func?.label}
      {count > 0 && (
        <Text float="right" as="span" fontWeight={400} fontSize="14px">
          {count}
        </Text>
      )}
    </Text>
  );
};

export const Functions = ({
  blueprints = [],
  selected = null,
  onClick = () => {},
}) => {
  const getCount = (func) => {
    return blueprints?.filter((bp) => bp?.tag_names?.includes(func?.value))
      ?.length;
  };
  return (
    <Box>
      <Text fontWeight="semiBold" fontSize="16px">
        Functions
      </Text>
      <Box mt="8px">
        {outreachFunctions?.map((func) => (
          <Function
            count={getCount(func)}
            key={func.value}
            func={func}
            onClick={onClick}
            selected={selected}
          />
        ))}
      </Box>
    </Box>
  );
};
